// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3isXD","field":"styles_field__1FTB-","fieldCol":"styles_fieldCol__wDMVg","diffCol":"styles_diffCol__3wz-t","diff":"styles_diff__34T4I"};